import MainLayout from "layouts/Main";
import { settingsTabs } from "views/Dashboard/Settings/tabs";

import UsersTable from "./UsersTable";

const Users = () => {
  return (
    <MainLayout tabs={settingsTabs}>
      <UsersTable />
    </MainLayout>
  );
};

export default Users;
